import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop: React.FC = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Try to find the main scrollable container first
    const main =
      document.getElementById("main-content") ??
      document.querySelector(".main-content");

    if (main) {
      // If there's a hash like #section, try to scroll that element into view inside main
      if (hash) {
        // Remove leading '#' and try to find sub-element inside main
        const id = hash.replace("#", "");
        const target = main.querySelector(`#${CSS.escape(id)}`);
        if (target instanceof HTMLElement) {
          // Smooth scroll the target into view within the container
          target.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
      }

      // Otherwise scroll container to top
      // Use instant for very snappy behavior; change to 'smooth' if you prefer animation
      if ("scrollTo" in main) {
        // @ts-ignore - some DOM libs treat HTMLElement vs Element
        main.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        // fallback
        (main as HTMLElement).scrollTop = 0;
      }
      return;
    }

    // Fallback: scroll window if no container found
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
